<div *ngIf="productConfigurationCartRowService.isProductConfiguration(row) && getDisplayMode() === 'inline'"
     class="cpq-cart-row-summary-inline small">
  <div *ngFor="let featureOptions of selectionsGroupedByFeature | keyvalue">
    <span class="font-weight-bold">{{ keyedFeatures.get(featureOptions.key).name }}:</span>
    {{ getOptionNames(featureOptions.value, featureOptions.key) }}
  </div>
  <a *ngIf="getEditLink() as editLink" class="btn btn-sm btn-outline-primary mt-1"
     [routerLink]="editLink.path" [queryParams]="editLink.queryParams"
     (click)="$event.stopPropagation()" translate>EDIT_CONFIGURATION</a>
</div>

<span *ngIf="productConfigurationCartRowService.isProductConfiguration(row) && getDisplayMode() === 'popover'"
      [popoverTitle]="title"
      [ngbPopover]="content"
      [autoClose]="'outside'"
      triggers="mouseenter"
      container="body">
  <i class="fa-regular fa-lightbulb-gear"></i>
</span>

<ng-template #title><span translate>CONFIGURATION_DETAILS</span></ng-template>
<ng-template #content>
  <span *ngFor="let featureOptions of selectionsGroupedByFeature | keyvalue">
    <span style="font-weight: bold;">{{keyedFeatures.get(featureOptions.key).name}}: </span>
    <span *ngFor="let option of featureOptions.value">{{ getOptionName(option, featureOptions.key) }}. </span>
    <br/>
  </span>
</ng-template>
